var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.featuresText[_vm.value]
    ? _c(
        "p",
        {
          directives: [
            {
              name: "tippy",
              rawName: "v-tippy",
              value: { followCursor: true, placement: "bottom-end" },
              expression: "{ followCursor: true, placement: 'bottom-end' }",
            },
          ],
          staticClass: "plans-feature",
          attrs: {
            content: _vm.featuresText[_vm.value](_vm.features[_vm.value]),
          },
        },
        [
          _c("i", { staticClass: "fa fa-check" }),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              _vm._s(_vm.featuresText[_vm.value](_vm.features[_vm.value]))
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }